/*
 * Background play on Android: the sound and the sleep timer run in a native foreground service (see
 * android/.../SleepSoundService.java), because Web Audio and JS timers stop once the WebView is backgrounded.
 * Everywhere else the page plays with Web Audio (soundEngine.ts).
 */
import {
    Capacitor,
    PluginListenerHandle,
    registerPlugin,
} from '@capacitor/core';

import { SleepSound } from './soundEngine';

export interface NativeSleepState {
    sound: SleepSound | null;
    /** Epoch milliseconds when the sound ends; 0 when nothing plays. */
    endsAt: number;
}

export interface NativeSleepStart {
    sound: SleepSound;
    minutes: number;
    fadeSeconds: number;
    /** Notification texts, already translated. */
    title: string;
    text: string;
    stopLabel: string;
}

export interface NativeSleep {
    start: (options: NativeSleepStart) => Promise<{ endsAt: number }>;
    stop: () => Promise<void>;
    getState: () => Promise<NativeSleepState>;
    addListener: (
        event: 'stopped',
        listener: () => void
    ) => Promise<PluginListenerHandle>;
}

export const nativeSleep = registerPlugin<NativeSleep>('SleepSounds');

/** Only the Android build has the service; iOS and the web play with Web Audio. */
export const hasNativeSleep = (
    platform: string = Capacitor.getPlatform()
): boolean => platform === 'android';
